import { useTranslation } from "react-i18next";
import { Section } from "react-scroll-section";
import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../style/css/Contact.css";
import Vector4 from "../assets/vector4.png";
import { FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { FiMail } from "react-icons/fi"
function Contact() {
  const { t } = useTranslation(["common"]);
  const [alert, setAlert] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.querySelector("form").reset()

    const labels = document.querySelectorAll(".form-control label");

    labels.forEach((label) => {
      label.innerHTML = label.innerText
        .split("")
        .map(
          (letter, idx) =>
            `<span style="transition-delay:${idx * 50}ms">${letter}</span>`
        )
        .join("");
    });
  }, [t]);

  const form = useRef();
  const [email, setEmail] = useState(undefined)


  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true)
    const isEmail = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(email)
    if (!isEmail || email === undefined) {
      setLoading(false)
      setAlert({ type: "error", message: t("emailError") })
      setTimeout(() => {
        setAlert({})
      }, 4000)
      return
    }

    emailjs
      .sendForm(
        "service_ibgijuw",
        "template_kxvd2qi",
        form.current,
        "XZdb7Lim1pjgyzyAs"
      )
      .then(
        (result) => {
          setAlert({ type: "success", message: t("success") })
          setTimeout(() => {
            setAlert({})
          }, 4000)

          document.querySelector("form").reset()
          setLoading(false)
        },
        (error) => {
          console.log(error)
          setAlert({ type: "error", message: t("error") })
          setTimeout(() => {
            setAlert({})
          }, 4000)
          document.querySelector("form").reset()
          setLoading(false)
        }
      );
  };

  return (
    <Section id="contact" style={{ width: "100%" }}>
      <div className="container c-container">
        <div className="form-container">
          <form ref={form} onSubmit={sendEmail}>
            <div className="form-control">
              <input type="text" name="user_name" required />
              <label>{t("user")}</label>
            </div>
            <div className="form-control">
              <input type="text" name="user_email" onChange={e => setEmail(e.target.value)} required />
              <label>{t("email")}</label>
            </div>
            <div className="form-control">
              <textarea name="user_message" placeholder={t("message")} required />
            </div>
            {loading ? (
              <button type="submit" style={{
                cursor: "not-allowed",
                background: "#068fe0"
              }} disabled>{t("pending")}</button>
            ) : (
              <button type="submit" >{t("send")}</button>
            )}
            {alert && (
              <p className={`alert-${alert.type}`}>{alert.message}</p>
            )}
          </form>
        </div>

        <div className="footer">

          <div>
            <a href="mailto:louisleca@zohomail.eu" className="mail"><FiMail /><span style={{ width: ".3rem" }}></span><span>louisleca@zohomail.eu</span></a>
            <a href="https://www.linkedin.com/in/louis-l-507a72173/" target="_blank" rel="noreferrer">
              <FaLinkedinIn className="icon" />
            </a>
            <a href="https://www.youtube.com/@Weboscopie" target="_blank" rel="noreferrer">
              <FaYoutube className="icon" />
            </a>
            <a href="https://github.com/LouisLeca22" target="_blank" rel="noreferrer">
              <BsGithub className="icon" />
            </a>

          </div>
          <img src={Vector4} alt="" className="vector4" />
        </div>

      </div>
    </Section>
  );
}

export default Contact;


